import Vue from "vue";
import Vuetify, {
  VApp,
  VContent,
  VContainer,
  VDialog,
  VBtn,
  VIcon,
  VLayout,
  VFlex,
  VCard,
  VCardTitle,
  VCardText,
  VCardActions,
  VCheckbox,
  VDivider,
  VProgressCircular,
  VExpansionPanel,
  VExpansionPanelContent,
  VToolbar,
  VToolbarTitle,
  VToolbarItems,
  VSpacer,
  VTextField,
  VSelect,
  VSwitch
} from "vuetify/lib";
import "vuetify/dist/vuetify.min.css";
import "@fortawesome/fontawesome-free/css/all.css";
import Colors from "vuetify/lib/util/colors";

Vue.use(Vuetify);

export default new Vuetify({
  components: {
    VApp,
    VContent,
    VContainer,
    VDialog,
    VBtn,
    VIcon,
    VLayout,
    VFlex,
    VCard,
    VCardTitle,
    VCardText,
    VCardActions,
    VCheckbox,
    VDivider,
    VProgressCircular,
    VExpansionPanel,
    VExpansionPanelContent,
    VToolbar,
    VToolbarTitle,
    VToolbarItems,
    VSpacer,
    VTextField,
    VSelect,
    VSwitch
  },
  theme: {
    themes: {
      light: {
        primary: "#a6ce38",
        secondary: "#00a09b",
        accent: Colors.amber,
        blueGrey: Colors.blueGrey,
        grey: Colors.grey,
        lightgrey: "#D7D7D7",
        success: "#a6ce38",
        error: "#D32F27"
      }
    },
    options: {
      customProperties: true
    }
  },
  icons: {
    iconfont: "fa"
  }
});
